import { useState } from 'react'
import { Link } from 'react-router-dom'
import './Header.css'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header className="header">
      <div className="container">
        <div className="nav-brand">
          <Link to="/" className="logo">
            <span className="logo-text">NEXPA</span>
            <span className="logo-tagline">Literacy Intelligence</span>
          </Link>
        </div>
        
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-menu">
            <li><Link to="/" onClick={() => setIsMenuOpen(false)}>홈</Link></li>
            <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>회사소개</Link></li>
            <li><Link to="/products" onClick={() => setIsMenuOpen(false)}>플랫폼</Link></li>
            <li><Link to="/contact" onClick={() => setIsMenuOpen(false)}>문의</Link></li>
          </ul>
        </nav>

        <button 
          className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}
          onClick={toggleMenu}
          aria-label="메뉴 토글"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  )
}

export default Header 